(() => {
  const styleId = 'vhalam-razorpay-desktop-width';
  const desktopStyles = `
    @media (min-width: 1200px) {
      :host {
        display: block;
        width: 100%;
      }
      main#mxWidget,
      main#mxWidget .container,
      main#mxWidget .wrapper {
        width: 100%;
        max-width: none;
        box-sizing: border-box;
      }
    }
  `;

  const applyWidth = () => {
    const widget = document.querySelector('#razorpay-affordability-widget main-component');
    const root = widget?.shadowRoot;
    if (!root) return false;
    if (root.getElementById(styleId)) return true;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = desktopStyles;
    root.append(style);
    return true;
  };

  const start = () => {
    if (applyWidth()) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (applyWidth() || attempts >= 100) window.clearInterval(timer);
    }, 200);
  };

  start();
  document.addEventListener('shopify:section:load', start);
})();
